<template>
	<RouterView :key="route.fullPath" />
</template>

<script>
	import {
		useRoute,
		RouterView
	} from 'vue-router';
	import {
		ref,
		watch
	} from 'vue';
	export default {
		name: 'App',
		components: {
			RouterView
		},
		setup() {
			const route = useRoute();
			const flag = ref('');

			(function getData() {
				flag.value = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				if(!flag.value) {
					window.location.href = 'https://ysdt.cdssjj.changde.gov.cn/pc/#/'
				}
			})();

			watch(route, () => {
				// console.log('变化', newValue, oldValue);
			})

			return {
				route,
				flag
			}
		}
	}
</script>

<style lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	body {
		/* background: #f7f7f7; */
		height: 100%;
	}

	#app {
		position: absolute;
		height: 100%;
		width: 100%;
	}

	.container {
		padding: 15px;
	}

	.container-full {
		padding: 0px;
	}


	@keyframes apple {
		from {
			transform: scale(1, 1);
			/* 初始大小 */
			opacity: 1;
			/* 初始透明度 */
		}

		to {
			transform: scale(4, 4);
			/* 最大大小 */
			opacity: 0;
			/* 结束透明度 */
		}
	}

	/* 创建涟漪元素 */
	.ripple {
		color: blue;
	}

	.el-drawer__header {
		margin-bottom: 0px !important;
	}

	/* 底部版权 */
	.footer {
		text-align: center;
		padding: 15px 0px 85px;
		color: #000;
		border-top: 2px #62a7f9 solid;
	}
</style>